import React from 'react';

interface TeamMember {
  name: string;
  role: string;
  image?: string;
  imagePosition?: string;
  bio: string[];
}

const team: TeamMember[] = [
  {
    name: "Giovana Prando Rigolo",
    role: "Farmacêutica",
    image: "/assets/team/giovana.png",
    imagePosition: "object-top",
    bio: [
      "Sou responsável pela condução dos processos e pelo acompanhamento das exigências técnicas e sanitárias dos clientes.",
      "Cada empresa atendida recebe análise individual, orientação clara e acompanhamento contínuo até a regularização completa."
    ]
  }
];

const Team: React.FC = () => {
  return (
    <section className="py-24 px-6 bg-[#f8f9fb]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-4">Nossa Equipe</h2>
          <p className="text-gray-500 text-lg">Conheça os farmacêuticos por trás da Dr. Alvará.</p>
        </div>

        <div className="max-w-4xl mx-auto">
          {team.map((member, index) => (
            <div key={index} className="flex flex-col md:flex-row gap-12 items-center md:items-start text-center md:text-left">
              <div className="w-48 h-48 rounded-full bg-gray-200 overflow-hidden flex-shrink-0 border-4 border-white shadow-sm flex items-center justify-center text-gray-400 font-medium">
                {member.image ? (
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className={`w-full h-full object-cover ${member.imagePosition || 'object-center'}`} 
                  />
                ) : (
                  "Foto"
                )}
              </div>
              <div>
                <h3 className="text-2xl font-bold text-brand-dark mb-1">{member.name}</h3>
                <p className="text-brand-blue font-medium mb-4">{member.role}</p>
                <ul className="space-y-2 text-gray-500 text-sm list-none">
                  {member.bio.map((item, i) => (
                    <li key={i} className="relative pl-4 before:content-['•'] before:absolute before:left-0 before:text-brand-blue">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
